import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Dashboard.css';
import { API_ENDPOINTS } from '../config/api';
import { getMenuItems } from '../config/menuItems';

const Dashboard = () => {
  const { t } = useTranslation();
  const [userRole, setUserRole] = useState(null);
  const [userFaculty, setUserFaculty] = useState(null);
  const [userProgram, setUserProgram] = useState(null);

  useEffect(() => {
    const checkUserRole = async () => {
      const akademisyenId = sessionStorage.getItem('akademisyen_id');
      if (!akademisyenId) return;

      try {
        const response = await fetch(API_ENDPOINTS.ROLES_ASSIGNMENTS);
        if (!response.ok) return;

        const assignments = await response.json();
        const userAssignments = assignments.filter(assignment =>
          assignment.akademisyen_id === parseInt(akademisyenId) && assignment.is_active
        );

        if (userAssignments.length > 0) {
          const primaryRole = userAssignments[0];
          setUserRole(primaryRole.role_name);
          setUserFaculty(primaryRole.faculty_name);
          setUserProgram(primaryRole.program_name);
        }
      } catch (error) {
        console.error('Rol bilgisi alınırken hata:', error);
      }
    };

    checkUserRole();
  }, []);

  const menuItems = getMenuItems(userRole, t);

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        {userRole && (
          <div className="dashboard-welcome">
            <h2>{t('dashboard.welcome')}</h2>
            {(userRole === 'Dekan' || userRole === 'Program Başkanı' || userRole === 'Rektör' || userRole === 'Rektör Yardımcısı') && (
              <div className="user-role-info">
                <span className="role-badge">{userRole}</span>
                {userFaculty && <span className="faculty-badge">{userFaculty}</span>}
                {userProgram && <span className="faculty-badge">{userProgram}</span>}
              </div>
            )}
          </div>
        )}
        
        <h3 className="dashboard-subtitle">{t('dashboard.managementPanel')}</h3>

        <div className="menu-grid">
          {menuItems.map((item) => (
            <Link key={item.path} to={item.path} className="menu-item">
              <h3>{item.label}</h3>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

